import { z } from 'zod';

import { paymentPlanSchema, upcomingPaymentsSchema } from '~/features/checkout/models/checkout';

import { removeCurrencyCode } from '../utils';

export const braavosProgramPriceSchema = z.object({
  payment_plans_v2: z.array(paymentPlanSchema),
  upcoming_payments: upcomingPaymentsSchema.optional(),
  coupon_applied: z.boolean(),
  coupon: z
    .object({
      percent_off: z.number(),
    })
    .nullable(),
  price: z.object({
    original_amount: z.number(),
    original_amount_display: z.string(),
    payable_amount: z.number(),
    payable_amount_display: z.string(),
  }),
});

export const braavosProgramPriceResponseSchema = z
  .object({
    results: z.array(braavosProgramPriceSchema),
  })
  .transform((value) => {
    const result = value?.results?.[0];
    const price = result?.payment_plans_v2?.[0]?.upfront_amount;
    if (!price) return null;

    return {
      displayPrice: removeCurrencyCode(price?.payable_amount_display),
      displayPriceUnits: '/one-time payment',
      couponApplied: result.coupon_applied,
      couponPercentOff: result.coupon?.percent_off,
      strikeThroughDisplayPrice:
        price.payable_amount < price.original_amount ? removeCurrencyCode(price.original_amount_display) : null,
    };
  });

export type BraavosProgramPrice = z.infer<typeof braavosProgramPriceSchema>;
export type BraavosProgramPriceResponse = z.infer<typeof braavosProgramPriceResponseSchema>;
